export default __webpack_public_path__ + "static/media/MERGADO_Audit_na_sirku.139acdbc.svg";